/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Balíček v přepravě`
};

const da_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Pakke under transport`
};

const de_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Paket unterwegs`
};

const en_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Parcel in transit`
};

const es_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Paquete en tránsito`
};

const fr_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Colis en transit`
};

const hu_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Csomag szállításban`
};

const it_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Pacco in transito`
};

const nl_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Pakket onderweg`
};

const pl_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Paczka w transporcie`
};

const pt_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Encomenda em trânsito`
};

const sv_order_statuses_complete_handled_by_carrier = /** @type {(inputs: {}) => string} */ () => {
	return `Paket på väg`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete_handled_by_carrier = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete_handled_by_carrier(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete_handled_by_carrier", locale)
	if (locale === "cs") return cs_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "da") return da_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "de") return de_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "en") return en_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "es") return es_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "fr") return fr_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "hu") return hu_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "it") return it_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "nl") return nl_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "pl") return pl_order_statuses_complete_handled_by_carrier(inputs)
	if (locale === "pt") return pt_order_statuses_complete_handled_by_carrier(inputs)
	return sv_order_statuses_complete_handled_by_carrier(inputs)
};
export { order_statuses_complete_handled_by_carrier as "order_statuses.complete_handled_by_carrier" }